// export default function QuantitySelect({
//                                            quantity = 1,
//                                            setQuantity = () => {},
//                                            styleClass = "",
//                                        }) {
//     return (
//         <>
//             <div className={`wg-quantity ${styleClass} `}>
//                 <button
//                     className="btn-quantity minus-btn"
//                     onClick={() => setQuantity(quantity > 1 ? quantity - 1 : quantity)}
//                 >
//                     -
//                 </button>
//                 <input
//                     className="quantity-product font-4"
//                     type="number"
//                     name="number"
//                     value={quantity}
//                     onChange={(e) => {
//                         const value = parseInt(e.target.value, 10);
//                         if (!isNaN(value) && value > 0) {
//                             setQuantity(value);
//                         }
//                     }}
//                 />
//                 <span
//                     className="btn-quantity plus-btn"
//                     onClick={() => setQuantity(quantity + 1)}
//                     role="button"
//                     tabIndex={0}
//                 >
//           +
//         </span>
//             </div>
//         </>
//     );
// }
export default function QuantitySelect({
                                           quantity = 1,
                                           setQuantity = () => {},
                                           max = 5,              // ⬅️ default 5
                                           min = 1,
                                           styleClass = "",
                                       }) {
    const clamp = (v) => Math.max(min, Math.min(max, v || 0));

    const dec = () => setQuantity(clamp(quantity - 1));
    const inc = () => setQuantity(clamp(quantity + 1));

    const onInput = (e) => {
        const n = parseInt(e.target.value, 10);
        setQuantity(Number.isFinite(n) ? clamp(n) : min);
    };

    const outOfStock   = max <= 0;
    const disableMinus = outOfStock || quantity <= min;
    const disablePlus  = outOfStock || quantity >= max;

    return (
        <div className={`wg-quantity ${styleClass}`}>
            <button
                type="button"
                className="btn-quantity minus-btn"
                onClick={dec}
                disabled={disableMinus}
            >
                -
            </button>

            <input
                className="quantity-product font-4"
                type="number"
                name="number"
                value={quantity}
                onChange={onInput}
                min={min}
                max={max}
                disabled={outOfStock}
            />

            <span
                className="btn-quantity plus-btn"
                onClick={inc}
                role="button"
                tabIndex={0}
                aria-disabled={disablePlus}
                style={{ pointerEvents: disablePlus ? "none" : "auto" }}
            >
        +
      </span>
        </div>
    );
}
